export class KeyboardEventHelper {
    static onKeyboardEvent(e) { // Backspace Tab Delete Home End Left Right number_pad_zero
        const specialKeys = [8, 9, 46, 36, 35, 37, 39, 96];
        let keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
        return ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 64 && keyCode <= 90) || keyCode == 32 || (keyCode >= 97 && keyCode <= 122) || (keyCode == 35) || (keyCode == 95)
            || (keyCode == 94) || (keyCode == 38) || (keyCode == 39) || (keyCode == 123) || (keyCode == 125) || (keyCode == 91) || (keyCode == 93) || (keyCode == 44) || (keyCode == 36) ||
            (keyCode == 61) || (keyCode == 45) || (keyCode == 40) || (keyCode == 41) || (keyCode == 37) || (keyCode == 46) || (keyCode == 43) || (keyCode == 126)
            || (specialKeys.indexOf(e.keyCode) != -1 && e.charCode != e.keyCode));
    }
}